import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getnewsAPi, createnewsAPi, uploadnewsAPi, deletenewsApi } from "../../../ApiUrl";
import { toast } from "react-toastify";

export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// create news
export const createnews = createAsyncThunk('createnews/news', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createnewsAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updatenews = createAsyncThunk('updatenews/news', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadnewsAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get news
export const getnews = createAsyncThunk('getnews/news', async () => {
    try {
        const response = await axios.get(`${getnewsAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'newss' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete news
export const deletenewss = createAsyncThunk('deletenewss/news', async (newsid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletenewsApi}/${newsid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'newsid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const newsSlice = createSlice({
    name: 'news',
    initialState: {
        newss: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create news
            .addCase(createnews.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createnews.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createnews.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update news
            .addCase(updatenews.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatenews.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.error(state.error);
                }
                state.status = 'idle';

            })
            .addCase(updatenews.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getnewss
            .addCase(getnews.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getnews.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.newss = action.payload;
            })
            .addCase(getnews.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete newss
            .addCase(deletenewss.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletenewss.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.newss.data = state.newss.data.filter(newss => newss.newsid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletenewss.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default newsSlice.reducer;
